module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-verticallabrettop.0417af34.png";